var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"px-10 py-4 md:px-16"},[_c('p',[_vm._v("This is just something to tell users to check out our channels page")]),_vm._v(" "),_c('p',[_vm._v("For now that should just be a list of the most commonly used genres")])])
}]

export { render, staticRenderFns }